import { useEffect, useState } from "react";
import { AuditCreate } from "./AuditCreate";
import { useLoaderData, useParams } from "react-router-dom";

import * as APIUSER from "../services/user";

export function AuditNew(props) {
  const audit = useLoaderData();

  const [isCreatingButton, setIsCreatingButton] = useState(false);
  const [isDeletingButton, setIsDeletingButton] = useState(false);


  // Set default valor for today date
  const todayDate = new Date()
    .toISOString()
    .replace(/T.*/, "")
    .split("-")
    .join("-");

  // Set number of sesion based on number of items published
  let auditLength = audit.length;
  let currentSesion = auditLength + 1;

  const [auditResp, setAuditResp] = useState(props.especialistaFullName);
  const [metaFecha, setAuditFecha] = useState(todayDate);
  const [auditFrecalcoh, setAuditFrecalcoh] = useState("");
  const [auditCuantbeb, setAuditCuantbeb] = useState("");
  const [auditFrecdia, setAuditFrecdia] = useState("");
  const [auditParar, setAuditParar] = useState("");
  const [auditHacer, setAuditHacer] = useState("");
  const [auditNeces, setAuditNeces] = useState("");
  const [auditRemord, setAuditRemord] = useState("");
  const [auditRecor, setAuditRecor] = useState("");
  const [auditHerid, setAuditHerid] = useState("");
  const [auditPreoc, setAuditPreoc] = useState("");

  // Sum of all AUDIT test responses
  const totalSumAudit =
    (parseInt(auditFrecalcoh) || 0) +
    (parseInt(auditCuantbeb) || 0) +
    (parseInt(auditFrecdia) || 0) +
    (parseInt(auditParar) || 0) +
    (parseInt(auditHacer) || 0) +
    (parseInt(auditNeces) || 0) +
    (parseInt(auditRemord) || 0) +
    (parseInt(auditRecor) || 0) +
    2 * (parseInt(auditHerid) || 0) +
    2 * (parseInt(auditPreoc) || 0);

  let { tratamientoId } = useParams();
  let { pacienteId } = useParams();

  const submitAudit = async (e) => {
    e.preventDefault();
    setIsCreatingButton(true);
    console.log(
      auditResp,
      metaFecha,
      auditFrecalcoh,
      auditCuantbeb,
      auditFrecdia,
      auditParar,
      auditHacer,
      auditNeces,
      auditRemord,
      auditRecor,
      auditHerid,
      auditPreoc,
      tratamientoId,
      pacienteId
    );
    try {
      await AuditCreate(
        auditResp,
        metaFecha,
        auditFrecalcoh,
        auditCuantbeb,
        auditFrecdia,
        auditParar,
        auditHacer,
        auditNeces,
        auditRemord,
        auditRecor,
        auditHerid,
        auditPreoc,
        tratamientoId,
        pacienteId
      ).then(
        (val) => {
          window.location.replace(`../audit/${val.id}`);
        },
        (error) => {
          console.log(error);
        }
      );
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      <div id='content'>
        <form
          id='formNewElement'
          className='newRadioButtons'
          onSubmit={submitAudit}
        >
          <div className='grid--2col'>
            <div className='field'>
              <label htmlFor='auditResp'>Responsable</label>
              <div className='control'>
                <input
                  className='input'
                  id='auditResp'
                  required
                  type='text'
                  value={auditResp}
                  onChange={(e) => setAuditResp(e.target.value)}
                />
              </div>
            </div>
            <div className='field'>
              <label htmlFor='metaFecha'>Fecha visita</label>
              <div className='control'>
                <input
                  className='input'
                  id='metaFecha'
                  required
                  type='date'
                  value={metaFecha}
                  onChange={(e) => setAuditFecha(e.target.value)}
                />
              </div>
            </div>
          </div>
          <h3>Cuestionario A.U.D.I.T.</h3>
          <div className='form-radio-container'>
            <div className='grid--2-col'>
              <div className='radio-capt radio--5-col'>
                <p>Nunca</p>
                <p>Mensualmente o menos</p>
                <p>2 a 4 veces al mes</p>
                <p>2 o 3 veces a la semana</p>
                <p>4 o más veces a la semana</p>
              </div>
            </div>
            <div className='field'>
              <div className='control grid--2col'>
                <label className='radio-title' htmlFor='auditFrecalcoh'>
                  1. ¿Con qué frecuencia se toma alguna bebida que contenga
                  alcohol?
                </label>
                <div className='radio--5-col'>
                  <label className='radio' htmlFor='auditFrecalcoh-0'>
                    <input
                      id='auditFrecalcoh-0'
                      name='auditFrecalcoh'
                      type='radio'
                      value='0'
                      checked={auditFrecalcoh === "0"}
                      onChange={(e) => setAuditFrecalcoh(e.target.value)}
                    />
                    0
                  </label>
                  <label className='radio' htmlFor='auditFrecalcoh-1'>
                    <input
                      id='auditFrecalcoh-1'
                      name='auditFrecalcoh'
                      type='radio'
                      value='1'
                      checked={auditFrecalcoh === "1"}
                      onChange={(e) => setAuditFrecalcoh(e.target.value)}
                    />
                    1
                  </label>
                  <label className='radio' htmlFor='auditFrecalcoh-2'>
                    <input
                      id='auditFrecalcoh-2'
                      name='auditFrecalcoh'
                      type='radio'
                      value='2'
                      checked={auditFrecalcoh === "2"}
                      onChange={(e) => setAuditFrecalcoh(e.target.value)}
                    />
                    2
                  </label>
                  <label className='radio' htmlFor='auditFrecalcoh-3'>
                    <input
                      id='auditFrecalcoh-3'
                      name='auditFrecalcoh'
                      type='radio'
                      value='3'
                      checked={auditFrecalcoh === "3"}
                      onChange={(e) => setAuditFrecalcoh(e.target.value)}
                    />
                    3
                  </label>
                  <label className='radio' htmlFor='auditFrecalcoh-4'>
                    <input
                      id='auditFrecalcoh-4'
                      name='auditFrecalcoh'
                      type='radio'
                      value='4'
                      checked={auditFrecalcoh === "4"}
                      onChange={(e) => setAuditFrecalcoh(e.target.value)}
                    />
                    4
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div className='form-radio-container'>
            <div className='grid--2-col'>
              <div className='radio-capt radio--5-col'>
                <p>1 ó 2</p>
                <p>3 ó 4</p>
                <p>5 ó 6</p>
                <p>7 a 9</p>
                <p>10 o más</p>
              </div>
            </div>
            <div className='field'>
              <div className='control grid--2col'>
                <label className='radio-title' htmlFor='auditCuantbeb'>
                  2. ¿Cuántas bebidas alcohólicas toma en un día normal cuando
                  bebe?
                </label>
                <div className='radio--5-col'>
                  <label className='radio' htmlFor='auditCuantbeb-0'>
                    <input
                      id='auditCuantbeb-0'
                      name='auditCuantbeb'
                      type='radio'
                      value='0'
                      checked={auditCuantbeb === "0"}
                      onChange={(e) => setAuditCuantbeb(e.target.value)}
                    />
                    0
                  </label>
                  <label className='radio' htmlFor='auditCuantbeb-1'>
                    <input
                      id='auditCuantbeb-1'
                      name='auditCuantbeb'
                      type='radio'
                      value='1'
                      checked={auditCuantbeb === "1"}
                      onChange={(e) => setAuditCuantbeb(e.target.value)}
                    />
                    1
                  </label>
                  <label className='radio' htmlFor='auditCuantbeb-2'>
                    <input
                      id='auditCuantbeb-2'
                      name='auditCuantbeb'
                      type='radio'
                      value='2'
                      checked={auditCuantbeb === "2"}
                      onChange={(e) => setAuditCuantbeb(e.target.value)}
                    />
                    2
                  </label>
                  <label className='radio' htmlFor='auditCuantbeb-3'>
                    <input
                      id='auditCuantbeb-3'
                      name='auditCuantbeb'
                      type='radio'
                      value='3'
                      checked={auditCuantbeb === "3"}
                      onChange={(e) => setAuditCuantbeb(e.target.value)}
                    />
                    3
                  </label>
                  <label className='radio' htmlFor='auditCuantbeb-4'>
                    <input
                      id='auditCuantbeb-4'
                      name='auditCuantbeb'
                      type='radio'
                      value='4'
                      checked={auditCuantbeb === "4"}
                      onChange={(e) => setAuditCuantbeb(e.target.value)}
                    />
                    4
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div className='form-radio-container'>
            <div className='grid--2-col'>
              <div className='radio-capt radio--5-col'>
                <p>Nunca</p>
                <p>Menos que mensualmente</p>
                <p>Mensualmente</p>
                <p>Semanalmente</p>
                <p>A diario o casi diario</p>
              </div>
            </div>
            <div className='field'>
              <div className='control grid--2col'>
                <label className='radio-title' htmlFor='auditFrecdia'>
                  3. ¿Con qué frecuencia se toma 6 o más bebidas que contengan
                  alcohol en una ocasión?
                </label>
                <div className='radio--5-col'>
                  <label className='radio' htmlFor='auditFrecdia-0'>
                    <input
                      id='auditFrecdia-0'
                      name='auditFrecdia'
                      type='radio'
                      value='0'
                      checked={auditFrecdia === "0"}
                      onChange={(e) => setAuditFrecdia(e.target.value)}
                    />
                    0
                  </label>
                  <label className='radio' htmlFor='auditFrecdia-1'>
                    <input
                      id='auditFrecdia-1'
                      name='auditFrecdia'
                      type='radio'
                      value='1'
                      checked={auditFrecdia === "1"}
                      onChange={(e) => setAuditFrecdia(e.target.value)}
                    />
                    1
                  </label>
                  <label className='radio' htmlFor='auditFrecdia-2'>
                    <input
                      id='auditFrecdia-2'
                      name='auditFrecdia'
                      type='radio'
                      value='2'
                      checked={auditFrecdia === "2"}
                      onChange={(e) => setAuditFrecdia(e.target.value)}
                    />
                    2
                  </label>
                  <label className='radio' htmlFor='auditFrecdia-3'>
                    <input
                      id='auditFrecdia-3'
                      name='auditFrecdia'
                      type='radio'
                      value='3'
                      checked={auditFrecdia === "3"}
                      onChange={(e) => setAuditFrecdia(e.target.value)}
                    />
                    3
                  </label>
                  <label className='radio' htmlFor='auditFrecdia-4'>
                    <input
                      id='auditFrecdia-4'
                      name='auditFrecdia'
                      type='radio'
                      value='4'
                      checked={auditFrecdia === "4"}
                      onChange={(e) => setAuditFrecdia(e.target.value)}
                    />
                    4
                  </label>
                </div>
              </div>
            </div>
            <div className='field'>
              <div className='control grid--2col'>
                <label className='radio-title' htmlFor='auditParar'>
                  4. ¿Con qué frecuencia en el último año ha sido incapaz de
                  parar de beber una vez había empezado?
                </label>
                <div className='radio--5-col'>
                  <label className='radio' htmlFor='auditParar-0'>
                    <input
                      id='auditParar-0'
                      name='auditParar'
                      type='radio'
                      value='0'
                      checked={auditParar === "0"}
                      onChange={(e) => setAuditParar(e.target.value)}
                    />
                    0
                  </label>
                  <label className='radio' htmlFor='auditParar-1'>
                    <input
                      id='auditParar-1'
                      name='auditParar'
                      type='radio'
                      value='1'
                      checked={auditParar === "1"}
                      onChange={(e) => setAuditParar(e.target.value)}
                    />
                    1
                  </label>
                  <label className='radio' htmlFor='auditParar-2'>
                    <input
                      id='auditParar-2'
                      name='auditParar'
                      type='radio'
                      value='2'
                      checked={auditParar === "2"}
                      onChange={(e) => setAuditParar(e.target.value)}
                    />
                    2
                  </label>
                  <label className='radio' htmlFor='auditParar-3'>
                    <input
                      id='auditParar-3'
                      name='auditParar'
                      type='radio'
                      value='3'
                      checked={auditParar === "3"}
                      onChange={(e) => setAuditParar(e.target.value)}
                    />
                    3
                  </label>
                  <label className='radio' htmlFor='auditParar-4'>
                    <input
                      id='auditParar-4'
                      name='auditParar'
                      type='radio'
                      value='4'
                      checked={auditParar === "4"}
                      onChange={(e) => setAuditParar(e.target.value)}
                    />
                    4
                  </label>
                </div>
              </div>
            </div>
            <div className='field'>
              <div className='control grid--2col'>
                <label className='radio-title' htmlFor='auditHacer'>
                  5. ¿Con qué frecuencia en el último año no pudo hacer lo que
                  se esperaba de usted como consecuencia de la bebida?
                </label>
                <div className='radio--5-col'>
                  <label className='radio' htmlFor='auditHacer-0'>
                    <input
                      id='auditHacer-0'
                      name='auditHacer'
                      type='radio'
                      value='0'
                      checked={auditHacer === "0"}
                      onChange={(e) => setAuditHacer(e.target.value)}
                    />
                    0
                  </label>
                  <label className='radio' htmlFor='auditHacer-1'>
                    <input
                      id='auditHacer-1'
                      name='auditHacer'
                      type='radio'
                      value='1'
                      checked={auditHacer === "1"}
                      onChange={(e) => setAuditHacer(e.target.value)}
                    />
                    1
                  </label>
                  <label className='radio' htmlFor='auditHacer-2'>
                    <input
                      id='auditHacer-2'
                      name='auditHacer'
                      type='radio'
                      value='2'
                      checked={auditHacer === "2"}
                      onChange={(e) => setAuditHacer(e.target.value)}
                    />
                    2
                  </label>
                  <label className='radio' htmlFor='auditHacer-3'>
                    <input
                      id='auditHacer-3'
                      name='auditHacer'
                      type='radio'
                      value='3'
                      checked={auditHacer === "3"}
                      onChange={(e) => setAuditHacer(e.target.value)}
                    />
                    3
                  </label>
                  <label className='radio' htmlFor='auditHacer-4'>
                    <input
                      id='auditHacer-4'
                      name='auditHacer'
                      type='radio'
                      value='4'
                      checked={auditHacer === "4"}
                      onChange={(e) => setAuditHacer(e.target.value)}
                    />
                    4
                  </label>
                </div>
              </div>
            </div>
            <div className='field'>
              <div className='control grid--2col'>
                <label className='radio-title' htmlFor='auditNeces'>
                  6. ¿Con qué frecuencia en el último año ha necesitado beber
                  por la mañana para recuperarse después de haber bebido mucho
                  el día anterior?
                </label>
                <div className='radio--5-col'>
                  <label className='radio' htmlFor='auditNeces-0'>
                    <input
                      id='auditNeces-0'
                      name='auditNeces'
                      type='radio'
                      value='0'
                      checked={auditNeces === "0"}
                      onChange={(e) => setAuditNeces(e.target.value)}
                    />
                    0
                  </label>
                  <label className='radio' htmlFor='auditNeces-1'>
                    <input
                      id='auditNeces-1'
                      name='auditNeces'
                      type='radio'
                      value='1'
                      checked={auditNeces === "1"}
                      onChange={(e) => setAuditNeces(e.target.value)}
                    />
                    1
                  </label>
                  <label className='radio' htmlFor='auditNeces-2'>
                    <input
                      id='auditNeces-2'
                      name='auditNeces'
                      type='radio'
                      value='2'
                      checked={auditNeces === "2"}
                      onChange={(e) => setAuditNeces(e.target.value)}
                    />
                    2
                  </label>
                  <label className='radio' htmlFor='auditNeces-3'>
                    <input
                      id='auditNeces-3'
                      name='auditNeces'
                      type='radio'
                      value='3'
                      checked={auditNeces === "3"}
                      onChange={(e) => setAuditNeces(e.target.value)}
                    />
                    3
                  </label>
                  <label className='radio' htmlFor='auditNeces-4'>
                    <input
                      id='auditNeces-4'
                      name='auditNeces'
                      type='radio'
                      value='4'
                      checked={auditNeces === "4"}
                      onChange={(e) => setAuditNeces(e.target.value)}
                    />
                    4
                  </label>
                </div>
              </div>
            </div>
            <div className='field'>
              <div className='control grid--2col'>
                <label className='radio-title' htmlFor='auditRemord'>
                  7. ¿Con qué frecuencia en el último año ha tenido
                  remordimientos o sentimientos de culpa después de haber
                  bebido?
                </label>
                <div className='radio--5-col'>
                  <label className='radio' htmlFor='auditRemord-0'>
                    <input
                      id='auditRemord-0'
                      name='auditRemord'
                      type='radio'
                      value='0'
                      checked={auditRemord === "0"}
                      onChange={(e) => setAuditRemord(e.target.value)}
                    />
                    0
                  </label>
                  <label className='radio' htmlFor='auditRemord-1'>
                    <input
                      id='auditRemord-1'
                      name='auditRemord'
                      type='radio'
                      value='1'
                      checked={auditRemord === "1"}
                      onChange={(e) => setAuditRemord(e.target.value)}
                    />
                    1
                  </label>
                  <label className='radio' htmlFor='auditRemord-2'>
                    <input
                      id='auditRemord-2'
                      name='auditRemord'
                      type='radio'
                      value='2'
                      checked={auditRemord === "2"}
                      onChange={(e) => setAuditRemord(e.target.value)}
                    />
                    2
                  </label>
                  <label className='radio' htmlFor='auditRemord-3'>
                    <input
                      id='auditRemord-3'
                      name='auditRemord'
                      type='radio'
                      value='3'
                      checked={auditRemord === "3"}
                      onChange={(e) => setAuditRemord(e.target.value)}
                    />
                    3
                  </label>
                  <label className='radio' htmlFor='auditRemord-4'>
                    <input
                      id='auditRemord-4'
                      name='auditRemord'
                      type='radio'
                      value='4'
                      checked={auditRemord === "4"}
                      onChange={(e) => setAuditRemord(e.target.value)}
                    />
                    4
                  </label>
                </div>
              </div>
            </div>
            <div className='field'>
              <div className='control grid--2col'>
                <label className='radio-title' htmlFor='auditRecor'>
                  8. ¿Con qué frecuencia en el último año no ha podido recordar
                  lo que sucedió la noche anterior porque había estado bebiendo?
                </label>
                <div className='radio--5-col'>
                  <label className='radio' htmlFor='auditRecor-0'>
                    <input
                      id='auditRecor-0'
                      name='auditRecor'
                      type='radio'
                      value='0'
                      checked={auditRecor === "0"}
                      onChange={(e) => setAuditRecor(e.target.value)}
                    />
                    0
                  </label>
                  <label className='radio' htmlFor='auditRecor-1'>
                    <input
                      id='auditRecor-1'
                      name='auditRecor'
                      type='radio'
                      value='1'
                      checked={auditRecor === "1"}
                      onChange={(e) => setAuditRecor(e.target.value)}
                    />
                    1
                  </label>
                  <label className='radio' htmlFor='auditRecor-2'>
                    <input
                      id='auditRecor-2'
                      name='auditRecor'
                      type='radio'
                      value='2'
                      checked={auditRecor === "2"}
                      onChange={(e) => setAuditRecor(e.target.value)}
                    />
                    2
                  </label>
                  <label className='radio' htmlFor='auditRecor-3'>
                    <input
                      id='auditRecor-3'
                      name='auditRecor'
                      type='radio'
                      value='3'
                      checked={auditRecor === "3"}
                      onChange={(e) => setAuditRecor(e.target.value)}
                    />
                    3
                  </label>
                  <label className='radio' htmlFor='auditRecor-4'>
                    <input
                      id='auditRecor-4'
                      name='auditRecor'
                      type='radio'
                      value='4'
                      checked={auditRecor === "4"}
                      onChange={(e) => setAuditRecor(e.target.value)}
                    />
                    4
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div className='form-radio-container'>
            <div className='grid--2-col'>
              <div className='radio-capt radio--3-col'>
                <p>No</p>
                <p>Sí, pero no en el último año</p>
                <p>Sí, en el último año</p>
              </div>
            </div>
            <div className='field'>
              <div className='control grid--2col'>
                <label className='radio-title' htmlFor='auditHerid'>
                  9. Usted o alguna otra persona ¿han resultado heridos como
                  consecuencia de su consumo de alcohol?
                </label>
                <div className='radio--3-col'>
                  <label className='radio' htmlFor='auditHerid-0'>
                    <input
                      id='auditHerid-0'
                      name='auditHerid'
                      type='radio'
                      value='0'
                      checked={auditHerid === "0"}
                      onChange={(e) => setAuditHerid(e.target.value)}
                    />
                    0
                  </label>
                  <label className='radio' htmlFor='auditHerid-1'>
                    <input
                      id='auditHerid-1'
                      name='auditHerid'
                      type='radio'
                      value='1'
                      checked={auditHerid === "1"}
                      onChange={(e) => setAuditHerid(e.target.value)}
                    />
                    1
                  </label>
                  <label className='radio' htmlFor='auditHerid-2'>
                    <input
                      id='auditHerid-2'
                      name='auditHerid'
                      type='radio'
                      value='2'
                      checked={auditHerid === "2"}
                      onChange={(e) => setAuditHerid(e.target.value)}
                    />
                    2
                  </label>
                </div>
              </div>
            </div>
            <div className='field'>
              <div className='control grid--2col'>
                <label className='radio-title' htmlFor='auditPreoc'>
                  10. ¿Algún familiar, amigo, médico o profesional sanitario han
                  mostrado preocupación por su consumo de alcohol o le han
                  sugerido que reduzca su consumo?
                </label>
                <div className='radio--3-col'>
                  <label className='radio' htmlFor='auditPreoc-0'>
                    <input
                      id='auditPreoc-0'
                      name='auditPreoc'
                      type='radio'
                      value='0'
                      checked={auditPreoc === "0"}
                      onChange={(e) => setAuditPreoc(e.target.value)}
                    />
                    0
                  </label>
                  <label className='radio' htmlFor='auditPreoc-1'>
                    <input
                      id='auditPreoc-1'
                      name='auditPreoc'
                      type='radio'
                      value='1'
                      checked={auditPreoc === "1"}
                      onChange={(e) => setAuditPreoc(e.target.value)}
                    />
                    1
                  </label>
                  <label className='radio' htmlFor='auditPreoc-2'>
                    <input
                      id='auditPreoc-2'
                      name='auditPreoc'
                      type='radio'
                      value='2'
                      checked={auditPreoc === "2"}
                      onChange={(e) => setAuditPreoc(e.target.value)}
                    />
                    2
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div className='form-results form-results-new form-results-audit'>
            <h3>Resultados de la autoevaluación AUDIT</h3>
            <p>Recuento total de puntos: {totalSumAudit}</p>
          </div>
        </form>
      </div>

      <div id='actions'>
        <button 
        className='button is-link' 
        form='formNewElement' 
        type='submit'
        disabled={ isCreatingButton}
        >
          {isCreatingButton ? <div className="spinner"></div> : 'Guardar'}
        </button>
      </div>
    </>
  );
}
